import React, { useEffect, useRef, useState } from 'react'
import logo from '../style/images/logo2.png'
import AboutUs from './AboutUs';
import WhyCatapult from './WhyCatapult';
import Gallery from './Gallery';
import Testimonials from './Testimonials';
import ContactUs from './ContactUs';
import Footer from './Footer';
import Slider from './Slider';
import ClientCarousel from './ClientCarousel';

const sectionsData = [
  { id: 'home', title: 'Welcome to Catapult Media Work', description: 'We don’t just manage events — we catapult your vision into reality.' },
  { id: 'about', title: 'ABOUT US' , subtitle: 'Best Corporate Event Organisers in Chennai', description: <AboutUs /> },
  { id: 'services', title: 'OUR SERVICES' },
  { id: 'gallery', title: 'GALLERY' },
  { id: 'contact', title: 'CONTACT US' }
];


const Header = () => {

    const [activeSection, setActiveSection] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const nav = navbarRef.current;
      if (scrollY > 100) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }

      sectionsData.forEach(section => {
        const el = document.getElementById(section.id);
        if (el) {
          const sectionTop = el.offsetTop;
          const sectionHeight = el.clientHeight;
          const scrollPosition = scrollY + nav.offsetHeight;
          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            setActiveSection(section.id);
          }
        }
      });

      document.querySelectorAll('section').forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (sectionTop < windowHeight - 150) {
          section.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const navHeight = navbarRef.current.offsetHeight;
    const target = document.getElementById(id);
    if (target) {
      const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - navHeight;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
    setMenuOpen(false);
  };


  return (
    <div>

        <header>
             
        <nav className="navbar" ref={navbarRef}>
           <div className='header-contact'>
          <a href="tel:+91 9655636360" className="contact-link">Call Us: +91 9655636360</a>
          <a href="mailto:reshmakr@catapultmediawork.com" className="contact-link">Email Us: reshmakr@catapultmediawork.com</a>
        </div>
<div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' , marginTop : '10px'}}>
          <div className="logo">
            <a href="#" onClick={() => scrollToSection('home')}>
                <img src={logo} alt="Logo" width={58} height={80}/>
                {/* catapult */}
            </a>
          </div>
          <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            {sectionsData.map(section => (
              <li key={section.id} className="nav-item">
                <a
                  href={`#${section.id}`}
                  className={`nav-link ${activeSection === section.id ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(section.id);
                  }}
                >
                  {section.id.charAt(0).toUpperCase() + section.id.slice(1)}
                </a>
              </li>
            ))}
          </ul>
          <div className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
</div>

        </nav>
      </header>

      <main>
        <section id="home" className="hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>{sectionsData[0].title}</h1>
            <p>{sectionsData[0].description}</p>
            <button className="cta-button" onClick={() => scrollToSection('about')}>Explore Now</button>
          </div>
        </section>

        {/* <Slider /> */}

        {/* {sectionsData.slice(1).map(section => ( */}
          {/* <section key={"home"} id={"home"} className="section">
            <div className="container">
              <h2 className="section-title">{section.title}</h2>
              <h3 className="about-subtitle">{section.subtitle}</h3>
              <div className="section-divider"></div>
            </div>
            {section.description}
          </section> */}
        {/* ))} */}

        <AboutUs />

        <WhyCatapult />

        <Gallery />

        <ClientCarousel />

        <Testimonials />

        <ContactUs />

<Footer />
      </main>

      {/* <footer className="footer">
        <div className="container">
          <p>&copy; 2025 Catapult Media Work. All Rights Reserved.</p>
        </div>
      </footer> */}
    </div>
  )
}

export default Header